'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;

    this.page = 1;
    this.params = {
      offset: this.page - 1,
      limit: 20,
      sortBy: 'createdAt',
      order: -1
    };
  }

  $onInit() {
    if (this.$stateParams.page) {
      this.page = this.$stateParams.page;
    }
    this.getBetaGroups();
  }

  getFirmwares() {
    this.params.offset = (this.page - 1) * this.params.limit;
    this.$http.get('/api/firmware', {params: this.params}).then(res => {
      this.firmwares = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/firmware/${id}`).then(res => {
        this.getFirmwares();
      });
    }
  }

  getBetaGroups() {
    this.$http.get('/api/betaGroups').then(res => {
      this.betaGroups = res.data;
      this.getFirmwares();
    });
  }

  findGroups(ids) {
    let groups = this.betaGroups.find(item => {
      return ids.indexOf(item._id) != -1;
    });
    return groups = groups.map(item => {
      return item.name;
    });
  }

  notify(id) {
    if (confirm("确定进行推送？")) {
      this.$http.get(`/api/firmware/${id}/notify`).then(res => {
        console.log(res);
      });
    }
  }

  pageChanged() {
    this.$state.go('firmwares.list', {page: this.page});
  }
}



// WEBPACK FOOTER //
// ./client/app/firmwares/list/list.controller.js